import React from 'react';
const printerImage = 'https://cdn.magicpatterns.com/uploads/kdoNQopwxwkR6wpm3PztRb/IT_stampante_modelli_premium_v01.png';
const steps = [{
  title: 'Scegli il tuo modello',
  text: 'Sfoglia i modelli del kit e seleziona quello che ti ispira.'
}, {
  title: 'Stampalo',
  text: 'Stampalo nella dimensione che preferisci, su un semplice foglio di carta.'
}, {
  title: 'Ricalca e dipingi',
  text: 'Posiziona il modello sotto il supporto trasparente, segui le linee con il contorno, poi aggiungi i colori.'
}, {
  title: 'Lascia asciugare e ammira il risultato',
  text: 'Rispetta i tempi di asciugatura indicati dal produttore dei materiali che usi, prima di decorare la tua casa o regalare la tua creazione.'
}];
export function HowItWorks() {
  return <section aria-labelledby="how-title" className="on-dark bg-teal text-ivory px-5 sm:px-8 py-16 sm:py-24" data-id="element-113" data-mp="grgv27q075tb">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 lg:grid-rows-[auto_1fr] gap-x-16 gap-y-10" data-id="element-114" data-mp="14hb6ckuocmbg">
        <div className="lg:col-start-2 lg:row-start-1" data-id="element-115" data-mp="19bp958bo1vq5">
          <h2 id="how-title" className="font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold" data-id="element-116" data-mp="2rmfwkwl8h0sd">
            Non serve saper disegnare
          </h2>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-ivory/85 max-w-lg" data-id="element-117" data-mp="31b7jurfcmwwy">
            Stampa il motivo che preferisci, posizionalo sotto un supporto
            trasparente adatto e segui i contorni.
          </p>
        </div>

        <figure className="lg:col-start-1 lg:row-start-1 lg:row-span-2" data-id="element-118" data-mp="3aaks5grqlfg3">
          <div className="aspect-[4/5] overflow-hidden rounded-[2rem] ring-1 ring-gold/40" data-id="element-119" data-mp="36bbysd0lzjl2">
            <img src={printerImage} alt="Stampante su un tavolo di legno che stampa un modello di iris al tratto, accanto ad altri modelli dettagliati con colibrì e farfalla e a una rosa posizionata sotto un supporto trasparente, con colori e pennello" loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-120" data-mp="3kalgjh4gqlr5" />
          </div>
          <figcaption className="mt-4 text-center text-xs font-semibold tracking-[0.08em] sm:tracking-[0.18em] text-ivory/80" data-id="element-121" data-mp="1kz2771f8zbgy">
            SCARICA · STAMPA · CREA
          </figcaption>
        </figure>

        <ol className="lg:col-start-2 lg:row-start-2 self-start" data-id="element-122" data-mp="3pytsun7l47bl">
          {steps.map((step, i) => <li key={step.title} className="relative grid grid-cols-[2.75rem_1fr] gap-x-4 pb-8 last:pb-0" data-id="element-123" data-mp="3tylwcli4fna3" data-mpi={i}>
              {i < steps.length - 1 && <span aria-hidden="true" className="absolute left-[1.375rem] top-12 bottom-1 w-px bg-ivory/25" data-id="element-124" data-mp="7syonhotbfg5" />}
              <span className="flex h-11 w-11 items-center justify-center rounded-full border border-ivory/35 font-serif text-lg font-semibold text-coral-light" data-id="element-125" data-mp="crs3bdfu5chw">
                {i + 1}
              </span>
              <div className="pt-1.5" data-id="element-126" data-mp="lkvaj3zw0t43">
                <h3 className="font-serif text-xl font-semibold" data-id="element-127" data-mp="lju1f52fmgp0">{step.title}</h3>
                <p className="mt-1.5 text-base leading-relaxed text-ivory/80" data-id="element-128" data-mp="qkhsfqqnuxj8">{step.text}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}